export default __webpack_public_path__ + "static/media/ic_user_login.32060eda.svg";